import React from "react";

const ContextApp = React.createContext({});

export default ContextApp;
